// extracted by mini-css-extract-plugin
export default {"button-80":"KakaoMap_button-80__1RpmE","button-left":"KakaoMap_button-left__8HZtz"};